module.exports = __webpack_public_path__ + "static/media/shiftDelete22.bed4ed7a.svg";